import React from 'react';
import { FieldArray } from 'formik';
import { Button, Field } from '@cordata/buffet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormGroup, Label } from 'reactstrap';

const OptionsField = ({ values }) => (
  <FieldArray name="options">
    {({ push, remove }) => (
      <FormGroup className="w-100">
        <div className="d-flex mb-1">
          <Label className="flex-grow-1">Options <span className="text-danger">*</span></Label>
          <Label className="mx-2" style={{ width: '80px' }}>Order</Label>
          <div style={{ width: '50px' }} />
        </div>
        {values.options && values.options.length > 0 ? (
          values.options.map((option, index) => (
            <div key={option.id || `option-${index}`} className="d-flex mb-2 w-100 ">
              <div className="flex-grow-1">
                <Field
                  label=""
                  name={`options.${index}.option_value`}
                  placeholder={`Option ${index + 1}`}
                  className="w-75"
                  required
                />
              </div>
              <div className="mx-2" style={{ width: '80px' }}>
                <Field
                  label=""
                  name={`options.${index}.sort_order`}
                  type="number"
                  placeholder="Order"
                />
              </div>
              <div>
                <Button
                  type="button"
                  color="danger"
                  outline
                  className="ml-2"
                  disabled={values.options.length === 1}
                  onClick={() => remove(index)}
                >
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </div>
            </div>
          ))
        ) : null}
        <Button
          type="button"
          color="primary"
          outline
          block
          onClick={() => push({ option_value: '', sort_order: values.options ? values.options.length : 0 })}
        >
          <FontAwesomeIcon icon="plus" />
          {' Add Option'}
        </Button>
      </FormGroup>
    )}
  </FieldArray>
);

export default OptionsField;
